export default {
  title: '佣金记录',
  body: {
    cmpt: {
      type: 'CCommissionRecord'
    }
  }
}
